var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.processoArquivado() &&
    _vm.showDesarquivamentoCard &&
    _vm.$route.name === "gerenciamento-daes"
    ? _c(
        "div",
        { staticClass: "card-info" },
        [
          _c("el-row", [
            _c("div", { staticClass: "d-flex tb" }, [
              _c("div", { staticClass: "column" }, [
                _c("p", { staticClass: "verde-text" }, [
                  _vm._v("Seu processo está arquivado")
                ]),
                _c("p", { staticClass: "verde-text" }, [
                  _vm._v(
                    "Clique no botão ao lado para desarquivá-lo. Ao clicar, será gerado um DAE de desarquivamento, após o pagamento o processo desarquivará de forma automática."
                  )
                ])
              ]),
              _c(
                "div",
                { staticClass: "botao" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "green textButtonBreak",
                      attrs: { tipo: "success" },
                      on: {
                        click: function($event) {
                          return _vm.consultarBoleto()
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "center" }, [
                        _c("i", { staticClass: "fal fa-credit-card" }, [
                          _vm._v(" "),
                          _c("span", [_vm._v("Desarquivar Processo")])
                        ])
                      ])
                    ]
                  )
                ],
                1
              )
            ])
          ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-50124ba6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50124ba6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/components/centralMensagens/AppAvisoDesarquivamento.vue
// module id = null
// module chunks = 